import { CATEGORY, withOneTrust } from '@narf/onetrust'
import { initTrack, optInTrack } from '@narf/track'
import { useUnauth } from '@narf/unauth'

import { useEffect } from 'react'

import { useAuth2 } from 'context/auth2'

const Mixpanel = () => {
  const { siteId: siteIdAuth2 } = useAuth2()
  const { siteId: siteIdUnauth } = useUnauth()
  const siteId = siteIdAuth2 || siteIdUnauth

  useEffect(() => {
    if (siteId) initTrack(siteId, process.env.CUSTOM_ENV)
  }, [siteId])

  useEffect(() => {
    // todo(fernando.cervera): add opt out
    withOneTrust(() => optInTrack(), CATEGORY.C0002)
  }, [])

  return null
}

export default Mixpanel
